module.exports = __webpack_public_path__ + "media/customizations/lmws/back-4c813f971f09de04bb3f83d7d286b479.jpg";